export default __webpack_public_path__ + "static/media/primeFactors.63857059.svg";